module.exports = __webpack_public_path__ + "img/qr_aClHh8.d152cceb.svg";